<template>
    <div class="export-dialog-div">
        <el-dialog :close-on-click-modal="false"   title="导出订单" :visible.sync="exportParam.visible" v-if="exportParam.visible"  :before-close="beforeClose">
            <el-form :model="exportForm" ref="exportForm" class="export-order-form" :rules="exportRule">
                <el-form-item label="导出页数：" label-width="100px" v-if="exportParam.type == 1">
                    <el-row style="display: flex;">
                            <el-form-item prop="startPage">
                                <el-input style="width: 150px" size="small" v-model="exportForm.startPage" placeholder="起始页码"></el-input>
                            </el-form-item>
                            -
                            <el-form-item prop="endPage">
                                <el-input style="width: 150px" size="small" v-model="exportForm.endPage" placeholder="结束页码"></el-input>
                            </el-form-item>
                    <span style="font-size: 12px">（每次最多导出20页）</span>
                    </el-row>
                </el-form-item>
                <el-form-item label="模板类型：" label-width="100px" prop="modeType">
                    <el-select clearable  v-model="exportForm.modeType" size="small">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <a style="margin-left: 20px;font-size: 12px;color: #337ab7" v-if="false">添加自定义模板</a>
                </el-form-item>
                <el-form-item label="导出项：" label-width="100px" v-if="exportForm.modeType == 0">
                    <el-checkbox disabled :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="checkedItems" @change="handleCheckedCitiesChange" class="check-group-export">
                        <el-row>
                            <el-col :span="4" class="ck-box-col">
                                <span>订单信息:</span>
                                <el-checkbox v-for="item in baseTemplate.orderInfo" :label="item" :key="item.value" class="ck-box-ex">{{item.label}}</el-checkbox>
                            </el-col>
                            <el-col :span="4" class="ck-box-col">
                                <span>买家信息:</span>
                                <el-checkbox v-for="item in baseTemplate.buyerInfo" :label="item" :key="item.value" class="ck-box-ex">{{item.label}}</el-checkbox>
                            </el-col>
                            <el-col :span="4" class="ck-box-col">
                                <span>报关与物流:</span>
                                <el-checkbox disabled v-for="item in baseTemplate.logisInfo" :label="item" :key="item.value" class="ck-box-ex">{{item.label}}</el-checkbox>
                            </el-col>
                            <el-col :span="4" class="ck-box-col">
                                <span>日期信息:</span>
                                <el-checkbox disabled v-for="item in baseTemplate.dateInfo" :label="item" :key="item.value" class="ck-box-ex">{{item.label}}</el-checkbox>
                            </el-col>
                            <el-col :span="4" class="ck-box-col">
                                <span>店长信息:</span>
                                <el-checkbox disabled v-for="item in baseTemplate.shopManageInfo" :label="item" :key="item.value" class="ck-box-ex">{{item.label}}</el-checkbox>
                            </el-col>
                        </el-row>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="cancle">关 闭</el-button>
                <el-button size="small" type="primary" @click="exportOrder">导 出</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"   title="导出订单" :visible.sync="exportResultVisible" width="500px">
            <div style="margin: 20px 10px 10px">
                <div v-if="this.exportOrderNum == null"><span>订单正在导出中，请稍后……</span></div>
                <div v-else><span>已导出: </span><span v-if="this.exportOrderNum != null" style="color: red">{{this.exportOrderNum}}</span><span>个订单</span></div>
                <div style="margin-top: 10px"><span>关闭本窗口后文件将被删除，请立即下载</span></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="exportResultVisible = false">关 闭</el-button>
                <el-button size="small" type="primary" @click="downloadExcel">下 载</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {exportExcel,downloadFile,loadAllAppIds} from '@/api/order/all'
    import {download} from '@/utils/jn'
    export default {
        name: "exportDialog",
        props:{
            exportParam:{
                type:Object,
                default:{
                    visible:false,
                    type:null,
                    orderIds:[]
                }
            }
        },
        data(){
            var validateNum = (rule, value, callback) => {
                if (!(/(^[1-9]\d*$)/.test(value))) {
                    callback(new Error("页码必须正整数"));
                }
                if(this.exportForm.startPage != null && this.exportForm.endPage != null){
                    if(this.exportForm.endPage < this.exportForm.startPage){
                        callback(new Error("结束页码小于起始页码！"));
                    }
                    if((this.exportForm.endPage - this.exportForm.startPage)> 19){
                        callback(new Error("导出页数超出范围！"));
                    }
                }
                return callback();
            };
            return{
                closeOnClickModal:false,
                exportResultVisible:false,
                exportForm:{
                    startPage:null,
                    endPage:null,
                    modeType:null
                },
                exportRule:{
                    startPage:[
                        {required: true, message: '起始页码不能为空', trigger: 'blur'},
                        {validator: validateNum, type: 'number'},
                    ],
                    endPage:[
                        {required: true, message: '结束页码不能为空', trigger: 'blur'},
                        {validator: validateNum, type: 'number'},
                    ],
                },
                options:[{label:'请选择模板', value:null},{label:'标准模板', value:0}],
                checkAll: false,
                exportItem:[],//导出项（已分类）
                isIndeterminate: true,
                // baseTemplate:[],//标准模板数据
                checkedItems:[],//所有选中的导出项
                // allExportItems:[],//所有待选到处向（未分类）,
                exportOrderNum:null,//导出的订单数量
                exportFileName:null,//导出文件的名称
            }
        },
        computed:{
            baseTemplate(){
                return this.$store.state.order.baseTemplate;
            },
            allExportItems(){
                let arr = this.$store.state.order.baseTemplate;
                this.baseTemplate = arr;
                let all = [];
                for(let key in arr){
                    all = all.concat(arr[key])
                }
                console.log(arr);
                console.log(all);
                return all;
            }
        },
        created(){},
        mounted(){
        },
        methods:{
            handleCheckAllChange(val) {
                this.checkedItems = val ? this.allExportItems : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(val) {
                let checkedCount = val.length;
                this.checkAll = checkedCount === this.allExportItems.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.allExportItems.length;
            },
            beforeClose(done){
                this.clearForm();
                done();
            },
            cancle(){
                this.clearForm();
                this.exportParam.visible = false;
            },
            clearForm(){
                this.exportForm.startPage = null;
                this.exportForm.endPage = null;
                this.exportForm.modeType = null;
                this.checkedItems = [];
            },
            exportOrder(){
                let that = this;
                if(this.exportForm.modeType == null){
                    this.$message.warning("请选择导出模板！");
                    return false;
                }
                if(this.checkedItems.length == 0 ){
                    this.$message.warning("请选择导出项！");
                    return false;
                }
                this.exportParam.fields = this.checkedItems;
                this.exportOrderNum = null;
                if(this.exportParam.type == 1){
                    this.exportParam.queryForm.startLimit = (this.exportForm.startPage-1)*10;
                    this.exportParam.queryForm.endLimit = this.exportForm.endPage*10;
                    loadAllAppIds(this.exportParam.queryForm).then(res => {
                        console.log(res);
                        this.exportParam.orderIds = res.data;
                        this.submitForm();

                    });
                }else if(this.exportParam.type == 0){
                    this.submitForm();
                }

            },
            submitForm(){
                let that = this;
                this.$refs['exportForm'].validate((valid) =>{
                    if(valid){
                        this.exportParam.visible = false;
                        // this.exportResultVisible = true;
                        exportExcel(this.exportParam).then(res => {
                            if(res.code = '200'){
                                console.log(res.data);
                                that.exportOrderNum = res.data.orderNum;
                                that.exportFileName = res.data.excelName;
                                download(this.exportFileName,true);
                                that.clearForm();
                            }else{
                                this.$message.error("导出订单失败！")
                            }
                        });
                    }else{
                        console.log("导出失败~");
                        return false;
                    }
                });
            },
            downloadExcel(){
                download(this.exportFileName,true);
                this.exportResultVisible = false;
            }
        }
    }
</script>

<style scoped>

</style>
